import { useNavigate } from "react-router-dom";
import { BoxInner, TextBox } from "style/modal";
import styled from "styled-components";

interface ModalProps {
  txt: string | null;
  closeModal?: () => void;
}

const ModalCenterCommonAlert = ({ txt, closeModal }: ModalProps) => {
  const navigate = useNavigate();

  const handleConfirm = () => {
    if (closeModal) {
      closeModal(); // 모달 닫기
    }
  };
  return (
    <ModalBoxInner>
      <TextBox>
        <p>{txt}</p>
      </TextBox>
      <div className="btn-box">
        <button onClick={handleConfirm}>확인</button>
      </div>
    </ModalBoxInner>
  );
};

export default ModalCenterCommonAlert;

const ModalBoxInner = styled(BoxInner)`
  gap: 1.4rem;
`;
